module.exports = __webpack_public_path__ + "static/img/D4105 - 副本 (2).dbe31372.png";